import React, { CSSProperties, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { setOptica, removeOptica } from "../../redux/actions/optica.action";

import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { removeHorario } from "../../redux/actions/horario.action";

import { TbCalendarTime } from "react-icons/tb";
import { RiMapPinUserFill } from "react-icons/ri";
import { Tracking } from "../../services/tracking.service";
import { LanguagesType } from "../../i18n/translate.dto";
import { useTranslation } from "react-i18next";
import { OpticDTO } from "../../services/DTOs_news/optics/optic.DTO";

const CardOptica = (props: any) => {
  const optic: OpticDTO = props.optic;
  const nearest: boolean = props.isNearest ?? false;
  const hideDistance: boolean = props.hideDistance ?? false;

  const reduxState = useSelector((state: any) => state);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();

  useEffect(() => {}, []);

  const selectOptic = () => {
    if (optic.id) {
      Tracking.trackOpticaSelecionada(optic.id);
    }
    if (reduxState.optic?.id !== optic.id) {
      dispatch(removeHorario());
    }
    dispatch(setOptica({ ...optic }));
    navigate("/horarios");
  };

  const distance =
    Math.round((optic.distanceFromCords ? optic.distanceFromCords : 0) * 10) /
    10;
  const redeableDistance =
    distance < 1 ? distance * 1000 + "m" : distance + "km";

  return (
    <>
      {nearest && (
        <div style={{
          backgroundColor: "#E5E7EB",
          padding: "1em 1.5em",
          marginBottom: "1em",
          display: "flex",
          alignItems: "center",
          gap: "0.5em"
        }}>
          <RiMapPinUserFill size={"1.3rem"} color="#1F2937" />
          <span style={{ color: "#1F2937", fontWeight: 500, fontSize: "1em" }}>
            {t(LanguagesType.Optic_nearest)}
          </span>
        </div>
      )}
      <Card
        style={styles.card}
        outline
        onClick={selectOptic}
      >
        <CardBody style={{ paddingBottom: 0 }}>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
            {optic.distanceFromCords && !hideDistance && (
              <Row>
                <span style={styles.cardSmallText} className="card-distance">
                  {redeableDistance} {t(LanguagesType.Of_distance)}
                </span>
              </Row>
            )}
            <Row>
              <span style={styles.cardTitleText} className="card-title">
                {optic.name}
              </span>
            </Row>
            <Row>
              <span style={styles.cardSmallText} className="card-title">
                {optic.direction}
              </span>
            </Row>
            <Row style={styles.lastRow}>
              <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className="d-flex justify-content-end align-items-center mt-3">
                <button
                  style={{
                    ...styles.button,
                    whiteSpace: "nowrap" as const, // Fix type error for whiteSpace
                  }}
                  className="align-self-end"
                >
                  {t(LanguagesType.Ask_date)}
                </button>
              </Col>
            </Row>
          </Col>
          {/* Add a > to the left of the card on the center verticaly*/}
        </Row>
      </CardBody>
    </Card>
    </>
  );
};

const styles = {
  card: {
    borderRadius: "0px",
    border: "0",
    borderBottom: "1px solid #E0E0E0",
    cursor: "pointer",
    backgroundColor: "#E6F3FF",
    marginBottom: "0.5em",
  } as CSSProperties,
  selectedCard: {
    borderRadius: "0px",
    border: "0",
    borderBottom: "1px solid #E0E0E0",
    cursor: "pointer",
    backgroundColor: "#E6F3FF",
  } as CSSProperties,
  nearestCard: {
    borderRadius: "0px",
    border: "0",
    borderBottom: "1px solid #E0E0E0",
    cursor: "pointer",
    backgroundColor: "#E6F3FF",
    marginBottom: "0.5em",
  } as CSSProperties,
  cardBody: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cardSmallText: {
    fontSize: "0.9em",
    fontWeight: 400,
    color: "#6B7280",
  } as CSSProperties,

  cardTitleText: {
    fontSize: "1.3em",
    fontWeight: 700,
    color: "#1F2937",
  } as CSSProperties,
  buttonBox: {
    height: "100%",
    cursor: "pointer",
    backgroundColor: "transparent",
    color: "#1F2937",
    border: "2px solid #1F2937",
    padding: "0.2em 1em",
  },
  button: {
    height: "auto",
    cursor: "pointer",
    backgroundColor: "transparent",
    color: "#1F2937",
    border: "2px solid #1F2937",
    padding: "0.6em 1.5em",
    borderRadius: "25px",
    fontWeight: 600,
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
  },
  lastRow: {
    marginBottom: "5%",
  },
};

export default CardOptica;
